import { Component, OnInit } from '@angular/core';
import {GlobalDataService, ResetAuthToken} from '../global-data.service';
import {AuthenticationService} from '../authentication-service.service';
import {Router} from '@angular/router';
import {Order} from '../app-models/models';
import {CreateOrderService} from '../create-order.service';
import {isNullOrUndefined} from "util";

@Component({
  selector: 'app-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.css'],
  providers: [CreateOrderService]
})
export class CreateOrderComponent implements OnInit {

  private compObj: Order;
  private actionMessage: string;
  private actionStatus = true;

  constructor(private globalDataService: GlobalDataService,
              private router: Router, private componentService: CreateOrderService) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
      this.componentService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
  }

  handleAuthenticationError(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
    else if (e.status === 403) {
      this.router.navigate(['/manage/partner']);
    }
  }

  main(result): void {
    this.compObj = new Order();
  }

  onSubmit() {
    this.actionMessage = null;
    this.componentService.createOrder(this.compObj).then(this.submitSuccess.bind(this))
      .catch(this.submitFail.bind(this));
  }

  submitFail(e) {

    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
    else {
      this.actionStatus = false;
      this.actionMessage = 'Submit Failed!';
    }
  }

  submitSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

}



// WEBPACK FOOTER //
// ./src/app/create-order/create-order.component.ts